import { render, staticRenderFns } from "./RemovePracticeMemberModal.vue?vue&type=template&id=5eb7f03c"
import script from "./RemovePracticeMemberModal.vue?vue&type=script&lang=js"
export * from "./RemovePracticeMemberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports